var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "cancellation-policy" }, [
    _c("div", { staticClass: "title mb-3" }, [
      _vm._v("\n        Buchen bei uns lohnt sich:\n    ")
    ]),
    _vm._v(" "),
    _c("ul", { staticClass: "tick-li" }, [
      _vm.showGeneral
        ? _c("li", [
            _c("span", { staticClass: "li-title" }, [
              _vm._v(_vm._s(_vm.voMsg("tpl.cancellation.freeCancellation")))
            ]),
            _vm._v(" "),
            _c("br"),
            _vm._v(_vm._s(_vm.localizedText) + "\n        ")
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.showDate
        ? _c("li", [
            _c("span", { staticClass: "li-title" }, [
              _vm._v(_vm._s(_vm.voMsg("tpl.cancellation.freeCancellation")))
            ]),
            _vm._v(" "),
            _c("br"),
            _vm._v(_vm._s(_vm.localizedText))
          ])
        : _vm._e(),
      _vm._v(" "),
      _c("li", [
        _c("span", { staticClass: "li-title" }, [
          _vm._v(_vm._s(_vm.voMsg("tpl.cancellation.bestPrice")))
        ]),
        _vm._v(" "),
        _c("br"),
        _vm._v(_vm._s(_vm.voMsg("tpl.cancellation.bestPriceWeb")))
      ])
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "payments-hint" }, [
      _vm._v(
        "\n        Zahlen Sie nach Abschluss der Buchung bequem über folgende Zahlungsarten: Überweisung, Mastercard, Visa\n    "
      )
    ]),
    _vm._v(" "),
    _vm._m(0)
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "paymentmethods" }, [
      _c("i", { staticClass: "fa-brands fa-uberweisung" }, [
        _c("img", {
          attrs: {
            alt: "",
            src:
              "https://r.v-office.com/preview/v2934/1743147686000/img/Ueberweisung_02.svg"
          }
        })
      ]),
      _vm._v(" "),
      _c("i", { staticClass: "fa-brands fa-cc-mastercard" }),
      _vm._v(" "),
      _c("i", { staticClass: "fa-brands fa-cc-visa" })
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }